<template>
  <div>
    <ZKLDistrbution
      title="人口数据季度对比（2020年第三季度、2020年第四季度、2021年第一季度、2021年第二季度）"
    />
    <ZKLRegisrd />
    <!-- 自然增长 -->
    <ZKLNaturalAdd />
    <!-- 人口自然增长率对比 -->
    <ZKLWaiLai />
    <!-- 常住人口性别比 -->
    <ZKLInfo />
    <!--婚姻状况 -->
    <ZKLHunYinZK />
    <!-- 受教育分析 -->
    <ZKLSjyFx />
    <ZKLDistrbution
      title="经济与就业数据季度对比（2020年第三季度、2020年第四季度、2021年第一季度、2021年第二季度）"
    />
    <!--  工作情况人口比-->
    <ZKLWordQing />
    <!-- 工作地点分布情况 -->
    <ZKLWorkFenPei />
  </div>
</template>

<script>
import ZKLDistrbution from "./cnps/Zkl-distrbution.vue";
import ZKLRegisrd from "./cnps/Zkl-region.vue";
import ZKLNaturalAdd from "./cnps/Zkl-naturalAdd.vue";
import ZKLWaiLai from "./cnps/Zkl-waiLai.vue";
import ZKLInfo from "./cnps/Zkl-info.vue";

import ZKLHunYinZK from "./cnps/Zkl-hunYinZK.vue";
import ZKLSjyFx from "./cnps/Zkl-sjyfx.vue";
import ZKLWordQing from "./cnps/Zkl-wordQing.vue";
import ZKLWorkFenPei from "./cnps/Zkl-workFenPei.vue";
export default {
  components: {
    ZKLDistrbution,
    ZKLRegisrd,
    ZKLNaturalAdd,
    ZKLWaiLai,
    ZKLInfo,
    ZKLHunYinZK,
    ZKLSjyFx,
    ZKLWordQing,
    ZKLWorkFenPei,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less"></style>
